var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("InPlayerVideoOverlay", [
    _c(
      "div",
      {
        staticClass: "animate__animated animate__fadeIn text-white text-center",
        class: _vm.$style.wrapper
      },
      [
        _c(
          "div",
          {
            staticClass: "text-white text-center",
            class: _vm.$style.loadingText
          },
          [
            _vm._v("\n      " + _vm._s(_vm.$t("loading")) + "\n      "),
            _c("span", { staticStyle: { transform: "translateY(12.5%)" } }, [
              _c("span", { class: _vm.$style.dot }, [_vm._v("•")]),
              _vm._v(" "),
              _c("span", { class: _vm.$style.dot }, [_vm._v("•")]),
              _vm._v(" "),
              _c("span", { class: _vm.$style.dot }, [_vm._v("•")])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }